module.exports = __webpack_public_path__ + "static/bus_station-cff10049a883f1df1126f350ee5c3111.png";